import { Banknote } from 'lucide-react';
import { KIND_LABEL, KIND_STYLE, type ShiftKind } from '../lib/shift-kind';
import { cn } from '../lib/utils';
import type { ObjectRow } from '../types';
import { ICON } from './ui';

/** 8-kleuren default palet voor objecten zonder color_accent. Geschikt op dark bg. */
const OBJECT_PALETTE = [
  '#3b82f6', // blue-500
  '#ec4899', // pink-500
  '#10b981', // emerald-500
  '#f59e0b', // amber-500
  '#8b5cf6', // violet-500
  '#14b8a6', // teal-500
  '#ef4444', // red-500
  '#6366f1', // indigo-500
];

export function objectColor(obj: ObjectRow | null | undefined): string {
  if (!obj) return '#64748b';
  if (obj.color_accent && /^#?[0-9a-fA-F]{6}$/.test(obj.color_accent.replace('#', ''))) {
    return obj.color_accent.startsWith('#') ? obj.color_accent : '#' + obj.color_accent;
  }
  return OBJECT_PALETTE[obj.id % OBJECT_PALETTE.length];
}

export function objectColorWithAlpha(obj: ObjectRow | null | undefined, alpha = 0.25): string {
  const hex = objectColor(obj);
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

const KINDS: ShiftKind[] = ['vroeg', 'laat', 'nacht', 'verlof', 'ziek'];

/** Wat de kleuren en markeringen in de kalender betekenen: één rustige regel onder het rooster. */
export function CalendarLegend() {
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 px-1 text-xs text-slate-400" aria-label="Legenda">
          {KINDS.map((k) => (
            <span key={k} className="inline-flex items-center gap-1.5">
              <span className={cn('h-2 w-2 rounded-full', KIND_STYLE[k].dot)} aria-hidden />
              {KIND_LABEL[k]}
            </span>
          ))}
          <span className="inline-flex items-center gap-1.5">
            <Banknote className={cn(ICON.sm, 'text-money')} aria-hidden /> Betaaldag
          </span>
          <span className="inline-flex items-center gap-1.5">
            <span className="h-3.5 w-0.5 rounded-full bg-brand-400" aria-hidden /> Start loonperiode
          </span>
          <span className="inline-flex items-center gap-1.5">
            <span className="h-2 w-2 rounded-full bg-rose-400" aria-hidden /> Feestdag (+50%, weekend +85%)
          </span>
    </div>
  );
}
